"use strict";
/*
 * Created on 2019-03-01
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntityEventFlag_1 = require("../../../core/model/event/EntityEventFlag");
/**
 * <p>
 * Flag indicating that sellout ended.
 * </p>
 *
 * <p>
 * There can be multiple types of sellout on product/site combination at one time (but only one combination for single type), we have to
 * save information about the type of sellout.
 * </p>
 *
 * @author JMr
 * @author JMe
 */


var SelloutEnded =
/*#__PURE__*/
function (_EntityEventFlag_1$En) {
  _inherits(SelloutEnded, _EntityEventFlag_1$En);

  /**
   * Ctor.
   *
   * @param selloutType type of sellout
   */
  function SelloutEnded(selloutType) {
    var _this;

    _classCallCheck(this, SelloutEnded);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutEnded).call(this));
    _this.title = selloutType;
    return _this;
  }

  _createClass(SelloutEnded, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return SelloutEnded;
}(EntityEventFlag_1.EntityEventFlag);

exports.SelloutEnded = SelloutEnded;
SelloutEnded.TAG = EntityEventFlag_1.EntityEventFlag.register(SelloutEnded);